// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"228":"38276f81","884":"7266a0cc","951":"1f1e5293"}[chunkId] + ".css";
};